import { filterObjectValues } from 'helpers/filter'

import { OpenMB } from 'models/open_mb'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api from '../api'
import { GetOpenMBListResponse, GetOpenMBParams } from './types'

export const openmbApi = api.injectEndpoints({
  endpoints: build => ({
    getOpenMBById: build.query<OpenMB, OpenMB['id']>({
      query: id => ({
        url: `/web/open_mb/${id}/`,
      }),
    }),
    getOpenMB: build.query<GetOpenMBListResponse, GetOpenMBParams>({
      query: params => ({
        url: `/web/open_mb/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    openMBStatistics: build.query<Array<IStatistic>, GetOpenMBParams>({
      query: params => ({
        url: `/web/open_mb/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    downloadOpenMBExcel: build.mutation<void, GetOpenMBParams>({
      query: params => ({
        url: `/web/open_mb/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
